export default __webpack_public_path__ + "static/media/11.44d2ba1e.png";